{
  "GENERAL_SETTINGS": {
    "LIMIT_MESSAGES": {
      "CONVERSATION": "You have exceeded the conversation limit. Hacker plan allows only 500 conversations.",
      "INBOXES": "You have exceeded the inbox limit. Hacker plan only supports website live-chat. Additional inboxes like email, WhatsApp etc. require a paid plan.",
      "AGENTS": "You have exceeded the agent limit. Your plan only allows {allowedAgents} agents.",
      "NON_ADMIN": "Please contact your administrator to upgrade the plan and continue using all features."
    },
    "TITLE": "Cài đặt tài khoản",
    "SUBMIT": "Cập nhật cài đặt",
    "BACK": "Trờ về",
    "DISMISS": "Dismiss",
    "UPDATE": {
      "ERROR": "Không thể cập nhật cài đặt, hãy thử lại!",
      "SUCCESS": "Đã cập nhật thành công cài đặt tài khoản"
    },
    "ACCOUNT_DELETE_SECTION": {
      "TITLE": "Delete your Account",
      "NOTE": "Once you delete your account, all your data will be deleted.",
      "BUTTON_TEXT": "Delete Your Account",
      "CONFIRM": {
        "TITLE": "Delete Account",
        "MESSAGE": "Deleting your Account is irreversible. Enter your account name below to confirm you want to permanently delete it.",
        "BUTTON_TEXT": "Xoá",
        "DISMISS": "Huỷ",
        "PLACE_HOLDER": "Vui lòng điền {accountName} để xác nhận"
      },
      "SUCCESS": "Account marked for deletion",
      "FAILURE": "Could not delete account, try again!",
      "SCHEDULED_DELETION": {
        "TITLE": "Account Scheduled for Deletion",
        "MESSAGE_MANUAL": "This account is scheduled for deletion on {deletionDate}. This was requested by an administrator. You can cancel the deletion before this date.",
        "MESSAGE_INACTIVITY": "This account is scheduled for deletion on {deletionDate} due to account inactivity. You can cancel the deletion before this date.",
        "CLEAR_BUTTON": "Cancel Scheduled Deletion"
      }
    },
    "FORM": {
      "ERROR": "Vui lòng sửa lỗi biểu mẫu",
      "GENERAL_SECTION": {
        "TITLE": "Cài đặt chung",
        "NOTE": ""
      },
      "ACCOUNT_ID": {
        "TITLE": "Tài khoản SID",
        "NOTE": "ID này là bắt buộc nếu bạn đang xây dựng tích hợp dựa trên API"
      },
      "AUTO_RESOLVE": {
        "TITLE": "Auto-resolve conversations",
        "NOTE": "This configuration would allow you to automatically resolve the conversation after a certain period of inactivity.",
        "DURATION": {
          "LABEL": "Inactivity duration",
          "HELP": "Time period of inactivity after which conversation is auto-resolved",
          "PLACEHOLDER": "30",
          "ERROR": "Auto resolve duration should be between 10 minutes and 999 days",
          "API": {
            "SUCCESS": "Auto resolve settings updated successfully",
            "ERROR": "Failed to update auto resolve settings"
          }
        },
        "MESSAGE": {
          "LABEL": "Custom auto-resolution message",
          "PLACEHOLDER": "Conversation was marked resolved by system due to 15 days of inactivity",
          "HELP": "Message sent to the customer after conversation is auto-resolved"
        },
        "PREFERENCES": "Preferences",
        "LABEL": {
          "LABEL": "Add label after auto-resolution",
          "PLACEHOLDER": "Select a label"
        },
        "IGNORE_WAITING": {
          "LABEL": "Skip conversations waiting for agent’s reply"
        },
        "UPDATE_BUTTON": "Save Changes"
      },
      "NAME": {
        "LABEL": "Tên tài khoản",
        "PLACEHOLDER": "Tên tài khoản của bạn",
        "ERROR": "Vui lòng nhập tên tài khoản hợp lệ"
      },
      "LANGUAGE": {
        "LABEL": "Ngôn ngữ",
        "PLACEHOLDER": "Tên tài khoản của bạn",
        "ERROR": ""
      },
      "DOMAIN": {
        "LABEL": "Tên miền email đến",
        "PLACEHOLDER": "Miền mà bạn sẽ nhận được email",
        "ERROR": ""
      },
      "SUPPORT_EMAIL": {
        "LABEL": "Email hỗ trợ",
        "PLACEHOLDER": "Email hỗ trợ của công ty bạn",
        "ERROR": ""
      },
      "AUTO_RESOLVE_IGNORE_WAITING": {
        "LABEL": "Exclude unattended conversations",
        "HELP": "When enabled, the system will skip resolving conversations that are still waiting for an agent's reply."
      },
      "AUDIO_TRANSCRIPTION": {
        "TITLE": "Transcribe Audio Messages",
        "NOTE": "Automatically transcribe audio messages in conversations. Generate a text transcript whenever an audio message is sent or received, and display it alongside the message.",
        "API": {
          "SUCCESS": "Audio transcription setting updated successfully",
          "ERROR": "Failed to update audio transcription setting"
        }
      },
      "AUTO_RESOLVE_DURATION": {
        "LABEL": "Inactivity duration for resolution",
        "HELP": "Duration after a conversation should auto resolve if there is no activity",
        "PLACEHOLDER": "30",
        "ERROR": "Auto resolve duration should be between 10 minutes and 999 days",
        "API": {
          "SUCCESS": "Auto resolve settings updated successfully",
          "ERROR": "Failed to update auto resolve settings"
        },
        "UPDATE_BUTTON": "Cập nhật",
        "MESSAGE_LABEL": "Custom resolution message",
        "MESSAGE_PLACEHOLDER": "Conversation was marked resolved by system due to 15 days of inactivity",
        "MESSAGE_HELP": "This message is sent to the customer when a conversation is automatically resolved by the system due to inactivity."
      },
      "FEATURES": {
        "INBOUND_EMAIL_ENABLED": "Tính liên tục của cuộc trò chuyện với email được kích hoạt cho tài khoản của bạn.",
        "CUSTOM_EMAIL_DOMAIN_ENABLED": "Bạn có thể nhận email trong miền tùy chỉnh của mình ngay bây giờ."
      }
    },
    "UPDATE_CHATWOOT": "Đã có bản cập nhật {latestChatwootVersion} cho Chatwoot. Vui lòng cập nhật phiên bản của bạn.",
    "LEARN_MORE": "Tìm hiểu thêm",
    "PAYMENT_PENDING": "Your payment is pending. Please update your payment information to continue using Chatwoot",
    "UPGRADE": "Upgrade to continue using Chatwoot",
    "LIMITS_UPGRADE": "Your account has exceeded the usage limits, please upgrade your plan to continue using Chatwoot",
    "OPEN_BILLING": "Open billing"
  },
  "FORMS": {
    "MULTISELECT": {
      "ENTER_TO_SELECT": "Bấm enter để chọn",
      "ENTER_TO_REMOVE": "Bấm enter để xoá",
      "NO_OPTIONS": "List is empty",
      "SELECT_ONE": "Chọn một",
      "SELECT": "Chọn"
    }
  },
  "NOTIFICATIONS_PAGE": {
    "HEADER": "Thông báo",
    "MARK_ALL_DONE": "Đánh dấu tất cả đã xong",
    "DELETE_TITLE": "đã xoá",
    "UNREAD_NOTIFICATION": {
      "TITLE": "Thông báo tin chưa đọc",
      "ALL_NOTIFICATIONS": "Xem tất cả thông báo",
      "LOADING_UNREAD_MESSAGE": "Đang tải thông báo tin chưa đọc...",
      "EMPTY_MESSAGE": "Bạn không có thông báo tin chưa đọc"
    },
    "LIST": {
      "LOADING_MESSAGE": "Đang tải thông báo...",
      "404": "Không có thông báo",
      "TABLE_HEADER": [
        "Tên",
        "Số điện thoại",
        "Các cuộc hội thoại",
        "Liên hệ lần cuối"
      ]
    },
    "TYPE_LABEL": {
      "conversation_creation": "Hội thoại mới mới",
      "conversation_assignment": "Hội thoại đã được phân công",
      "assigned_conversation_new_message": "Tin nhắn mới",
      "participating_conversation_new_message": "Tin nhắn mới",
      "conversation_mention": "Nhắc đến",
      "sla_missed_first_response": "SLA Missed",
      "sla_missed_next_response": "SLA Missed",
      "sla_missed_resolution": "SLA Missed"
    }
  },
  "NETWORK": {
    "NOTIFICATION": {
      "OFFLINE": "Không Trực Tuyến",
      "RECONNECTING": "Reconnecting...",
      "RECONNECT_SUCCESS": "Reconnected"
    },
    "BUTTON": {
      "REFRESH": "Làm mới"
    }
  },
  "COMMAND_BAR": {
    "SEARCH_PLACEHOLDER": "Tìm kiếm hoặc nhảy đến",
    "SNOOZE_PLACEHOLDER": "Type a time e.g. tomorrow, 2 hours, next friday, jan 15...",
    "SECTIONS": {
      "GENERAL": "Chung",
      "REPORTS": "Báo cáo",
      "CONVERSATION": "Hội thoại",
      "BULK_ACTIONS": "Bulk Actions",
      "CHANGE_ASSIGNEE": "Thay đổi người được phân công",
      "CHANGE_PRIORITY": "Change Priority",
      "CHANGE_TEAM": "Thay đổi nhóm",
      "SNOOZE_CONVERSATION": "Tạm dừng \bhội thoại",
      "ADD_LABEL": "Thêm nhãn vào hội thoại",
      "REMOVE_LABEL": "Xoá nhãn khỏi hội thoại",
      "SETTINGS": "Cài đặt",
      "AI_ASSIST": "AI Assist",
      "APPEARANCE": "Appearance",
      "SNOOZE_NOTIFICATION": "Snooze Notification"
    },
    "COMMANDS": {
      "GO_TO_CONVERSATION_DASHBOARD": "Đi tới Trang tổng quan hội thoại",
      "GO_TO_CONTACTS_DASHBOARD": "Đi tới Trang tổng quan liên hệ",
      "GO_TO_REPORTS_OVERVIEW": "Đi đến Tổng quan Báo cáo",
      "GO_TO_CONVERSATION_REPORTS": "Đi tới Trang Báo cáo hội thoại",
      "GO_TO_AGENT_REPORTS": "Đi đến Báo cáo Tổng đài viên",
      "GO_TO_LABEL_REPORTS": "Đi đến Báo cáo Nhãn",
      "GO_TO_INBOX_REPORTS": "Đi đến Báo cáo Kênh",
      "GO_TO_TEAM_REPORTS": "Đi đến Báo cáo Nhóm",
      "GO_TO_SETTINGS_AGENTS": "Đi đến Cài đặt Tổng đài viên",
      "GO_TO_SETTINGS_TEAMS": "Đi đến Cài đặt Nhóm",
      "GO_TO_SETTINGS_INBOXES": "Đi đến Cài đặt Kênh",
      "GO_TO_SETTINGS_LABELS": "Đi đến Cài đặt Nhãn",
      "GO_TO_SETTINGS_CANNED_RESPONSES": "Đi đến Cài đặt Tin trả lời mẫu",
      "GO_TO_SETTINGS_APPLICATIONS": "Đi đến Cài đặt Ứng dụng",
      "GO_TO_SETTINGS_ACCOUNT": "Đi đến Cài đặt Tài khoản",
      "GO_TO_SETTINGS_PROFILE": "Đi đến Cài đặt Hồ sơ",
      "GO_TO_NOTIFICATIONS": "Đi đến Thông báo",
      "ADD_LABELS_TO_CONVERSATION": "Thêm nhãn vào hội thoại",
      "ASSIGN_AN_AGENT": "Gán cho tổng đài viên",
      "AI_ASSIST": "AI Assist",
      "ASSIGN_PRIORITY": "Assign priority",
      "ASSIGN_A_TEAM": "Phân công một nhóm",
      "MUTE_CONVERSATION": "Tắt tiếng hội thoại",
      "UNMUTE_CONVERSATION": "Bật tiếng hội thoại",
      "REMOVE_LABEL_FROM_CONVERSATION": "Xoá nhãn khỏi hội thoại",
      "REOPEN_CONVERSATION": "Mở lại hội thoại",
      "RESOLVE_CONVERSATION": "Giải quyết hội thoại",
      "SEND_TRANSCRIPT": "Gửi bản ghi qua email",
      "SNOOZE_CONVERSATION": "Tạm dừng \bhội thoại",
      "UNTIL_NEXT_REPLY": "Cho đến phản hồi kế tiếp",
      "UNTIL_NEXT_WEEK": "Cho đến tuần sau",
      "UNTIL_TOMORROW": "Cho đến ngày mai",
      "UNTIL_NEXT_MONTH": "Until next month",
      "AN_HOUR_FROM_NOW": "Until an hour from now",
      "UNTIL_CUSTOM_TIME": "Custom...",
      "CHANGE_APPEARANCE": "Change Appearance",
      "LIGHT_MODE": "Light",
      "DARK_MODE": "Dark",
      "SYSTEM_MODE": "System",
      "SNOOZE_NOTIFICATION": "Snooze Notification"
    }
  },
  "DASHBOARD_APPS": {
    "LOADING_MESSAGE": "Đang tải dữ liệu..."
  },
  "COMMON": {
    "OR": "Or",
    "CLICK_HERE": "click vào đây"
  }
}
